(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/account-balance/assets/javascripts/account-balance.js') >= 0) return;  svs.modules.push('/components/components/account-balance/assets/javascripts/account-balance.js'); 'use strict';

svs.components = svs.components || {};
svs.components.account_balance = svs.components.account_balance || {};
var lastUpdated = null,
    accountBalance = null;
var BALANCE_CACHE_TIME = 3 * 60 * 1000,
log = new svs.core.log.Logger('svs.components.account_balance');

if (svs.components.account_balance.data && svs.components.account_balance.data.ss_account_balance) {
  log.debug('Retrieved serverside account balance data, using to seed cache');
  accountBalance = svs.components.account_balance.data.ss_account_balance.balance;
  lastUpdated = Date.now();
  delete svs.components.account_balance.data.ss_account_balance;
}


var get = function get(forceRetrieveBalanceFromJupiter, callback, context) {
  if (typeof forceRetrieveBalanceFromJupiter === 'function') {
    callback = forceRetrieveBalanceFromJupiter;
    context = callback;
    forceRetrieveBalanceFromJupiter = false;
  }

  log.debug('Getting account balance');

  if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
    if (!forceRetrieveBalanceFromJupiter && accountBalance && lastUpdated && Date.now() - lastUpdated < BALANCE_CACHE_TIME) {
      if (callback) {
        log.debug('Get cached balance');
        callback.call(context, accountBalance);
      }
    } else {
      try {
        log.debug('Get balance from jupiter');
        svs.core.jupiter.call({
          method: 'GET',
          path: '/player/info?include=accountBalance'
        }, function (response) {
          log.debug('Account balance retrieved.');
          var retrievedAccountBalance = response.accountBalance;
          set(retrievedAccountBalance);

          if (callback) {
            callback.call(context, retrievedAccountBalance);
          }
        }, function (jqXHR, textStatus, err) {
          var error = 'Failed to retrieve account balance.';

          if (err) {
            error += " Error: ".concat(err);
          }

          log.error(error);

          if (callback) {
            callback.call(context, accountBalance, err);
          }
        });
      } catch (ex) {
        log.error("Generic error: Failed to retrieve account balance, error: ".concat(ex.message, ".").concat(ex.stack));

        if (callback) {
          callback.call(context, accountBalance, ex);
        }
      }
    }
  } else {
    if (callback) {
      callback.call(context, null);
    }
  }
};


var set = function set(newAccountBalance) {
  lastUpdated = Date.now();

  if (newAccountBalance !== accountBalance) {
    accountBalance = newAccountBalance;
    svs.components.account_balance.trigger('change', accountBalance);
  }
};

var reset = function reset() {
  lastUpdated = accountBalance = undefined;
};

svs.components.account_balance = new svs.core.Events({
  get: get,
  set: set,
  reset: reset
});
 })(window);